import React from 'react';
import { Calendar, X } from 'lucide-react';
import { formatDaysUntil } from '../utils/DateUtils';
import '../Counter.css';

const AnniversaryCard = ({ anniversary, onDelete }) => {
  return (
    <div className="anniversary-card">
      <div className="anniversary-info">
        <Calendar size={18} />
        <div>
          <div className="anniversary-title">{anniversary.title}</div>
          <div className="anniversary-date">
            {formatDaysUntil(anniversary.daysUntil)}
          </div>
        </div>
      </div>
      <button className="delete-btn" onClick={() => onDelete(anniversary.id)}>
        <X size={16} />
      </button>
    </div>
  );
};

export default AnniversaryCard;